import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
// import { registerServiceWorker } from '../registerServiceWorker';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// Day.js global konfigurieren
import './app/_utils/dayjs.config';

if (environment.production) {
  enableProdMode();
  // registerServiceWorker();
}

platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
  .catch(err => console.log(err));
